import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetProjectFilesDto, GetProjectFilesResponse } from '../../lib/types'
import { projectFilesMappers } from '../../lib'

const getprojectfiles = async (params: GetProjectFilesDto) => {
  const res = await api.json<GetProjectFilesResponse>(API_END_POINTS.project.getProjectFiles(params))
  if (res.ok) return projectFilesMappers.mapProjectFiles(res.result || {})
  if (!res.ok) throw new Error(res?.message || res?.error)
}

export default getprojectfiles
